export enum TAB_VALUE {
  PENDENCIES = "PENDENCIES"
}

export type TAB = {
  title: string;
};
